import * as React from "react";
import {cx} from "emotion";

import "./slider-checkbox.scss";

import {cs} from "../../react/chain-services";

const SPACE = " ";

export const SliderCheckbox = (
    {
        value=false, onChange=undefined, disabled=undefined, size=undefined,
        dark=false,
        xdQaType=undefined, xdQaName=undefined,
    }
    :{
        value?: boolean,
        onChange?: (value: boolean) => void,
        disabled?: boolean,
        size?: any, // TODO: type
        dark?: boolean,
        xdQaType?: string,
        xdQaName?: string,
    }
) => cs(
    ({}) => (
        <div
            className={cx("checkbox slider-checkbox slider-checkbox-31q", {checked: !!value, disabled, dark}, size)}
            onClick={(e) => {
                if (onChange && !disabled) {
                    e.stopPropagation();
                    onChange(!value);
                }
            }}
            xd-qa-type={xdQaType??"checkbox"}
            xd-qa-name={xdQaName}
            tabIndex={0}
            onKeyDown={(e) => e.key === SPACE && onChange && !disabled && onChange(!value)}
        >
            <div className="circle"/>
        </div>
    ),
);
